/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Cell } from "react-table";
import { Text } from "@nordcloud/gnui";

type EnvironmentType = {
  name: string;
  orgUnitsV2: {
    orgUnits: {
      businessContext: {
        id: string;
      };
      name: string;
    }[];
  };
};

export function ConflictsListColumns(structureId: string) {
  return [
    {
      Header: "Environment name",
      accessor: "name",
      disableSortBy: true,
      width: "5rem",
      Cell: ({ row }: Cell<EnvironmentType>) => {
        return (
          <Text size="sm" tag="div" css={{ wordBreak: "break-all" }}>
            {row.original.name}
          </Text>
        );
      },
    },
    {
      Header: "Current Organization unit",
      accessor: "orgunit",
      disableSortBy: true,
      width: "5rem",
      hasLeftBorder: true,
      Cell: ({ row }: Cell<EnvironmentType>) => {
        return (
          <Text size="sm" tag="div" css={{ wordBreak: "break-all" }}>
            {
              row.original.orgUnitsV2?.orgUnits?.find(
                (ou) => ou.businessContext.id === structureId
              )?.name
            }
          </Text>
        );
      },
    },
  ];
}
